@if (isActive()) {
    @if (loading()) {
        <div class="flex min-h-[450px] items-center justify-center">
            <ui-m000-c040-loading-spinner />
        </div>
    } @else if (!success()) {
        <div class="inner-page-wrapper mx-auto min-h-[730px] py-48">
            <p
                class="z-999 inner-page-wrapper w-full bg-red py-8 text-center font-headline text-14 font-medium leading-27 text-white"
            >
                Leider konnte das Formular nicht erfolgreich übermittelt werden. Bitte versuchen Sie es erneut oder
                wenden Sie sich an Ihren Händler, falls das Problem weiterhin besteht.
            </p>
        </div>
    } @else if (success()) {
        <div class="flex flex-col md:grid md:grid-cols-2 xl:flex xl:flex-row xl:items-center">
            <ui-m000-c010-image
                class="lg:w-500 block h-full"
                [classList]="'h-full aspect-[7/5] object-cover'"
                [image]="{
                    image: 'https://res.cloudinary.com/hmd-pw-dfnosvs4u/image/upload/v1726470580/HWS_Service_Header_qsodlw.jpg',
                    desktop: { width: 1169, height: 835 },
                    tablet: { width: 512, height: 390 },
                    mobile: { width: 767, height: 548 },
                }"
                [priority]="true"
                [alt]="'Service Anfrage - Bildbeispiel'"
                cover
                highRes
            />
            <div
                class="flex flex-col items-start justify-center p-24 text-black md:p-56 lg:min-w-[540px] xl:w-1/2 xl:pr-[112px]"
            >
                <h1 class="text-31 leading-36 md:text-34 md:leading-41">
                    Ihre Anfrage wurde
                    <br class="hidden md:block" />
                    erfolgreich versendet.
                </h1>

                <div class="w-full whitespace-pre-line">
                    <div class="mb-[20px] mt-16 text-16 leading-27">
                        <p>
                            Vielen Dank, wir haben Ihre Anfrage erhalten.
                            <br />
                            Wir werden Sie schnellstmöglich kontaktieren.
                            <br />
                            <br />
                            Ihr {{ dealerName() }} Team
                        </p>
                    </div>

                    <a class="button-primary md:w-auto" [hyundaiRouterLink]="'/' + dealer().slug">Zur Startseite</a>
                </div>
            </div>
        </div>
    }
}
